"use client";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/reveal";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { iconsMap } from "@/components/icons";
import Link from "next/link";
import { PortableText } from "next-sanity";
import { getURL } from "@/lib/utils";
import { components } from "../portable-text";
import { CtaSectionType } from "./closing";
import { SanityImage } from "@/components/sanity-image";

export function OpeningCTA({ data }: { data: CtaSectionType }) {
  const { heading, subheading, description, image, buttons } = data;
  return (
    <section className="py-24 px-8 bg-white">
      <div className="grid grid-cols-12 grid-rows-[auto_auto] gap-4 max-w-screen-2xl lg:px-24 mx-auto gap-y-8">
        <Reveal className="flex col-span-12 flex-col lg:grid  lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-6">
            <h3 className="font-medium text-xl lg:text-3xl 2xl:text-4xl">{heading}</h3>
            {subheading && <h4>{subheading}</h4>}
          </div>
          <div className="lg:col-span-6 flex flex-col gap-4">
            {description && (
              <PortableText
                value={description}
                components={{
                  ...components,
                }}
              />
            )}
            <div className="flex flex-row gap-4">
              {buttons &&
                buttons.map((cta, index) => {
                  const href = getURL(cta);
                  return (
                    <Button
                      variant={cta.variant}
                      radius="full"
                      className="w-fit"
                      asChild={true}
                      key={index}
                    >
                      <Link
                        href={href}
                        target={cta.openInNewTab ? "_blank" : "_self"}
                        rel={cta.openInNewTab ? "noopener noreferrer" : undefined}
                      >
                        {cta.textBeforeIcon}
                        {cta.icon && iconsMap[cta.icon]}
                        {cta.textAfterIcon}
                      </Link>
                    </Button>
                  );
                })}
            </div>
          </div>
        </Reveal>
        <div className="w-full col-span-12">
          <Reveal>
            <AspectRatio ratio={1108 / 936}>
              {image && (
                <SanityImage
                  src={image}
                  alt={image.alt || ""}
                  fill
                  placeholder="blur"
                  blurDataURL={image.asset?.metadata?.lqip || ""}
                  className="object-cover rounded-2xl cursor-pointer border-4 border-primary-500"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              )}
            </AspectRatio>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
